import { Address, defaultAddress } from '../contacts/address';
import { PhoneNumber, defaultPhoneNumber } from '../contacts/phoneNumber';

export interface InsuredPerson {
    id: number; 
    insuredName: string;
    firstName: string; 
    preferredName: string; 
    lastName: string; 
    middleName: string; 
    mailingAddress: Address;
    homeNumber: PhoneNumber;
    cellNumber: PhoneNumber; 
    workNumber: PhoneNumber; 
}

export const defaultInsuredPerson: InsuredPerson = {
    id: 0, 
    insuredName: '',
    firstName: '', 
    preferredName: '', 
    lastName: '', 
    middleName: '',     
    mailingAddress: defaultAddress,
    homeNumber: defaultPhoneNumber,
    cellNumber: defaultPhoneNumber,
    workNumber: defaultPhoneNumber,
}
